module.exports = __webpack_public_path__ + "static/media/whyus_etica.d5ca64e6.jpg";